/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonBase,
  PersonBaseOptional,
  PersonBaseMetaI,
  PersonBaseTrackedI,
} from "./person-base";
import { PersonBaseTracked, PersonBaseMeta } from "./person-base";

/**
 *
 * @export
 * @interface PersonRelationABase
 */
export interface PersonRelationABaseOptional {
  /**
   *
   * @type {PersonBase}
   * @memberof PersonRelationABase
   */
  B?: PersonBaseOptional;
}

export interface PersonRelationABase extends PersonRelationABaseOptional {
  /**
   *
   * @type {PersonBase}
   * @memberof PersonRelationABase
   */
  B: PersonBase;
}

export interface PersonRelationABaseTrackedI {
  /**
   *
   * @type {PersonBase}
   * @memberof PersonRelationABase
   */
  B?: PersonBaseTrackedI;
  BIsSet: boolean;
}

transformDatesMap.set(
  "PersonRelationABase",
  function (model: PersonRelationABase) {
    const transformDatesB = transformDatesMap.get("PersonBase");
    if (transformDatesB && model.B) {
      transformDatesB(model.B);
    }
  },
);

export type PersonRelationABaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  B: PropertyMeta<PersonBaseMetaI>;
}>;

export var PersonRelationABaseMeta: PersonRelationABaseMetaI =
  {} as PersonRelationABaseMetaI;
PersonRelationABaseMeta = typeMeta("PersonRelationABase", {
  B: propertyMeta("B", false, true, false, PersonBaseMeta),
});

const metaI = PersonRelationABaseMeta;

registerMeta(() => {});

export class PersonRelationABaseTracked implements PersonRelationABaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  B__I?: PersonBaseTracked = undefined;
  BIsSet: boolean = false;
  set B(v: undefined | PersonBaseTracked) {
    if (v !== undefined) {
      this.B__I = v;
      this.BIsSet = true;
    } else {
      this.B__I = v || undefined;
      this.BIsSet = true;
    }
    this.changeTracker = true;
  }
  get B() {
    return this.B__I;
  }
  constructor(config?: PersonRelationABaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.B?.setIds();
  }
  assignFrom(
    config: PersonRelationABaseOptional,
    options?: AssignOptions,
  ): PersonRelationABaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.B && this.BApplyFilter(optionsRequired.filter)) {
      this.B = new PersonBaseTracked(config.B, options);
      if (optionsRequired.unassign) this.BIsSet = false;
      else this.BIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonRelationABaseTrackedI {
    const cloned = {} as PersonRelationABaseTrackedI;
    if (
      this.BIsSetDeep() &&
      this.BApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.BIsSet = true;
      cloned.B = this.B?.removeUnset(filter);
    } else {
      //cloned.BIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonRelationABaseTrackedI {
    if (!this.BApplyFilter(filter)) this.BIsSet = false;
    this.B?.unassignAll(filter);

    return this;
  }
  BApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationABaseMeta.B,
      PersonRelationABaseMeta,
      this.B,
      this,
    );
  }
  BIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.BIsSet && this.BApplyFilter(filter)) return true;
    return this.B?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.BIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
